import APP_ACTIONS from '../constants/app-actions';

const error = {
    doError: (error) => ({
        type: APP_ACTIONS.ADD_ERROR,
        payload: error,
    }),

    doErrorLineItems: (lineItemsError) => ({
        type: APP_ACTIONS.ERRORS_LINE_ITEMS,
        payload: lineItemsError,
    }),

    clearErrorLineItems: () => ({
        type: APP_ACTIONS.CLEAR_ERRORS_LINE_ITEMS,
    }),
};

export default error;



/** WEBPACK FOOTER **
 ** ./src/actions/error.js
 **/